import React, {useEffect, useState} from 'react';
import {callAPI} from "../../../lib/common";

export const CheckoutContext = React.createContext();

export default  ({children}) => {
  const [state, setState] = useState({
    deliveryOption: null,
    paymentOption: null,
    requestingTransactionUuidError: null,
    requestingTransactionUuid: false,
    transactionUuid: null,
    paymentType: null,
    customerInfo: {},
    orderInfo: null,
    rebateCode: null
  });

  useEffect(() => {
    const {paymentOption, deliveryOption} = state;
      // Get checkout content:
    callAPI(`/m/api/checkout/order-lines`, 'POST', {
      paymentOption: paymentOption ? paymentOption.uuid : '',
      deliveryOption: deliveryOption ? deliveryOption.uuid : ''
    })
      .then(data => {
        setState((state) => ({
          ...state,
          orderInfo: data
        }))
      });
  }, [state.paymentOption, state.deliveryOption, state.rebateCode]);

  let termsOfPurchase = null;


  useEffect(() => {
    console.log('Rendering checkout provider');
  }, [])

  const getTermsOfPurchase = () => {
     return window.NTLF_ToP;
  }

  const setDeliveryOption = (deliveryOption) => {
    setState((state) => ({
      ...state,
        deliveryOption
    }))
  }

  const setDeliveryType = (deliveryType) => {
    setState((state) => ({
      ...state,
      deliveryType
    }))
  }

  const setPaymentOption = (paymentOption) => {
    setState((state) => ({
      ...state,
      paymentOption
    }))
  }

  const setRebateCode = (rebateCode) => {
    setState((state) => ({
        ...state,
        rebateCode
      })
    )
  }

  const requestTransactionUuid = () => {
    console.log('Request payment token');
    setState((state) => ({
      ...state,
      requestingTransactionUuid: true,
      requestTransactionUuidError: null
    }));

    const customerInfo = {...state.customerInfo};
    console.log('Customer info', customerInfo);
    customerInfo.zipcode = customerInfo.postalCode;
    delete customerInfo.postalCode;

    const payload = {
      ...customerInfo,
      paymentoption: state.paymentOption.uuid,
      deliveryoption: state.deliveryOption.uuid,
      cartfallback: true,
      ordercomment: ''
    }

    console.log('Payload', payload)

    callAPI('/ajax/get_transaction.php', 'POST', payload)
      .then(data => {
        if (data.error) {
          setState((state) => ({
            ...state,
            requestTransactionUuidError: data.error
          }));
          return;
        }

        setState(state => {
         return {
           ...state,
           transactionUuid: data.transactionid
         }
        })

      })
      .finally(() => {
        setState((state) => ({
          ...state,
          requestingTransactionUuid: false
        }));
      })
  }

  const updateCustomerInfo = (data) => {
    setState((state) => ({
      ...state,
      customerInfo: {...state.customerInfo,
        ...data
      }
    }));
  }

  console.log('Delivery option', state.deliveryOption);

  return <CheckoutContext.Provider
  value={{state,
    setDeliveryOption,
    setDeliveryType,
    setPaymentOption,
    requestTransactionUuid,
    updateCustomerInfo,
    getTermsOfPurchase,
    setRebateCode
  }}>
    {children}
  </CheckoutContext.Provider>
}


const useCheckout = () => {
    return React.useContext(CheckoutContext);
}

export {
  useCheckout
}